import axios, { AxiosResponse } from "axios";
import {UploadFileResponse} from "./requestsResponses";

import { API_URL } from "../../apiCommandsExecutor/apiMethods";
import { getToken } from "../../apiCommandsExecutor/token";


export const uploadFile = async (file: File, mediaType?: string, sourceIdentifier?: string) => {
    let formData = new FormData();
    formData.append('file', file);
    if (sourceIdentifier) formData.append('sourceIdentifier', sourceIdentifier)
    let host:string;
    if (mediaType && mediaType !== "zonesType") {
        formData.append('mediaType', mediaType);
        host = `${API_URL}/api/upload/menu_item`;
    } else if (mediaType && mediaType === "zonesType")  {
        host = `${API_URL}/api/upload/delivery_zones`;
    } else  host = `${API_URL}/api/upload`;


    const res: AxiosResponse <UploadFileResponse> = await axios.post(host,
        formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "AuthToken": getToken(),
            },
        }
    );
    return res.data;
};


